import React, { useState } from "react";
import { forgetPasswordAPI } from "../../Services/authService.js";
import { Form, SmartFormField, SubmitButton } from "../ui/Form";
import { forgetPasswordSchema } from "../../schemas/forgetPasswordSchema";
import { useTranslation } from "react-i18next";

export default function Component() {
  const { t } = useTranslation();
  const [message, setMessage] = useState("");

  const handleResetPassword = async (data, { setFormError }) => {
    setMessage("");

    try {
      const response = await forgetPasswordAPI(data.email);
      if (response.status === 200) {
        setMessage(t("career.resetLinkSent"));
      } else {
        throw new Error(response.data.error || "Failed to send reset link");
      }
    } catch (error) {
      const errorMessage = error.response?.data?.error || error.message || "An error occurred";
      throw new Error(errorMessage);
    }
  };

  return (
    <div className="flex justify-center items-center min-h-screen bg-gray-100">
      <div className="mx-auto max-w-md p-6 bg-white rounded-lg shadow-md space-y-6">
        <div className="space-y-2 text-center">
          <h1 className="text-3xl font-bold">{t("career.forgotPasswordTitle")}</h1>
          <p className="text-gray-600">
            {t("career.forgotPasswordDesc")}
          </p>
        </div>

        <Form
          schema={forgetPasswordSchema}
          onSubmit={handleResetPassword}
          defaultValues={{ email: "" }}
          className="space-y-4"
        >
          <SmartFormField
            name="email"
            label={t("career.email")}
            type="email"
            required
            inputProps={{
              placeholder: "m@example.com",
              variant: "box"
            }}
          />

          <SubmitButton
            variant="primary"
            size="md"
            fullWidth
          >
            {t("career.resetPassword")}
          </SubmitButton>
        </Form>

        {message && (
          <p className="text-center text-green-600 font-medium">{message}</p>
        )}
      </div>
    </div>
  );
}
